import { injectable } from "@launchtray/tsyringe-async";
import { SceneManager } from "../../../../scene/SceneManager";
import { ModuleFlowExecutor } from "../../../composition/module/ModuleFlowExecutor";
import { PreloaderScene } from "../PreloaderScene";
import { PreloaderModule } from "./PreloaderModule";

@injectable()
export class PreloaderModuleFlowExecutor extends ModuleFlowExecutor<PreloaderModule> {
    public override async execute(module: PreloaderModule): Promise<void> {
        const sceneManager = await module.resolve(SceneManager);
        const preloaderScene = await module.resolve(PreloaderScene);
        this.notifySplashScreenWeReady();
        await sceneManager.showViewableAsync(preloaderScene);
    }

    private notifySplashScreenWeReady(): void {
        document.dispatchEvent(new Event("application-ready"));
    }
}